import React from 'react';
import { TableHead } from './table';
import { ChevronUp, ChevronDown } from 'lucide-react';
import { cn } from '../../lib/utils';
import { SortDirection } from '../../hooks/useTableSort';

interface SortableTableHeadProps {
  children: React.ReactNode;
  sortKey: string;
  onSort: (key: string) => void;
  sortDirection: SortDirection;
  className?: string;
}

export const SortableTableHead: React.FC<SortableTableHeadProps> = ({
  children,
  sortKey,
  onSort,
  sortDirection,
  className
}) => {
  const handleClick = () => {
    onSort(sortKey);
  };
 
  
  // Get sort icon
  const getSortIcon = (key: string) => {
    if (sortKey !== key || !sortDirection) {
      return <div className="h-4 w-4 text-gray-400" />;
    }
    return sortDirection === 'asc' ? 
      <ChevronUp className="h-4 w-4 text-blue-600" /> : 
      <ChevronDown className="h-4 w-4 text-blue-600" />;
  };

  return (
    <TableHead 
      className={cn(
        "cursor-pointer select-none hover:bg-gray-50 transition-colors",
        className
      )}
      onClick={handleClick}
    >
       <div className="flex items-center justify-between gap-1 w-full min-w-0">
         <span className="whitespace-nowrap truncate flex-1">{children}</span>
         <div className="flex-shrink-0">
           {getSortIcon(sortKey)}
         </div>
        {/* <div className="flex flex-col">
          <ChevronUp 
            className={cn(
              "h-3 w-3 transition-colors",
              sortDirection === 'asc' ? "text-blue-600" : "text-gray-400"
            )} 
          />
          <ChevronDown 
            className={cn(
              "h-3 w-3 -mt-1 transition-colors",
              sortDirection === 'desc' ? "text-blue-600" : "text-gray-400"
            )} 
          />
        </div> */}
      </div>
    </TableHead>
  );
};
